import React, { useState } from "react";
import ExternalSelectAutocomplete from "react-select";
import PropTypes from "prop-types";
import classNames from "classnames";
import {
  Grid,
  Input,
  SelectAutocomplete,
  Radio,
} from "@design-system-coopeuch/web";
import ItemValidation from "../../molecules/ItemValidation/ItemValidation";
import SimpleCard from "../../molecules/SimpleCard/SimpleCard";
import Skeleton from "../../atoms/Skeleton/Skeleton";
import { constants } from "../../../../domain/constants";
import {
  StyledWrapperInput,
  WrapperRadio,
} from "../../../assets/styles/styles";
import { StyledIconOffice } from "./styles";
import iconExecutive from "../../../assets/img/icon-executive.svg";
import MapVector from "../../../assets/img/map-vector.png";

const MAX_EXECUTIVE_CODE = constants.MAX_EXECUTIVE_CODE;
/* istanbul ignore next */
const CardPreferredOffice = (props) => {
  const {
    regionsWithOfficesItems,
    officesItems,
    preferredOffice,
    executiveCode,
    executive,
    executiveAttending,
    isVisiblePreferredOffice,
    isLoadingFetchExecutive,
    isValidExecutiveCode,
    isMobileDevice,
    disabled,
    onChange,
    onChangeRegion,
    onChangeOffice,
    onChangeExecutiveCode,
  } = props;
  /* istanbul ignore next */
  const [selectedRegionId, setSelectedRegionId] = useState(null);
  /* istanbul ignore next */
  const handleExecutiveRadioChange = (value) => {
    onChange({
      field: "executiveAttending",
      property: "value",
      value,
    });
  };
  /* istanbul ignore next */
  const renderExecutiveCodeInput = () => (
    <Grid row className="p-0 m-0">
      <Grid className="p-0 m-0" col={12} md={4}>
        <StyledWrapperInput withoutmaxlength>
          <Input
            value={executiveCode.value}
            label="Ingresa el código (opcional)"
            placeholder="Ejemplo: PHLM"
            maxLength={MAX_EXECUTIVE_CODE}
            onChange={onChangeExecutiveCode}
            allowSpaces
            autoComplete="new-password"
          />
        </StyledWrapperInput>
        <article className="p-0 pt-1">
          {isValidExecutiveCode === "valid" &&
            executiveCode.value.length === 4 && (
              <ItemValidation
                type="success"
                fontSize="12"
                className={classNames("mt-0")}
              >
                <p className="text-color-success line-height-20">
                  Código correcto
                </p>
              </ItemValidation>
            )}
          {isValidExecutiveCode === "invalid" && (
            <p className="text-color-64 font-size-12 line-height-18">
              No tenemos registro de este código. Vuelve a intentarlo o continúa
            </p>
          )}
        </article>
      </Grid>
      {executive.nombre && executiveCode.value.length === 4 && (
        <Grid
          className="p-0 mb d-flex align-items-start pt-3 pt-md-7 pl-md-5"
          col={12}
          md={8}
        >
          <img src={iconExecutive} width="24" alt="ejecut" />
          <p className="ml-1 font-size-16 line-height-20 font-weight-bold text-color-38">
            {executive.nombre || "XXXX"}
          </p>
        </Grid>
      )}
    </Grid>
  );
  /* istanbul ignore next */
  return (
    <SimpleCard
      contentHeader={
        <p className="simplecard__title">
          Sucursal de preferencia para ser atendido
        </p>
      }
      disabled={disabled}
    >
      <Grid className="m-0 padding-16 p-md-6">
        <Grid className="p-0 mb-2">
          <p className="font-size-16 line-height-24 font-weight-bold">
            Selecciona la sucursal donde retirarás tu Tarjeta de Débito
          </p>
        </Grid>
        <Grid className="p-0 m-0" row>
          <Grid className="p-0 m-0 mb-4 mb-md-0" col={12} sm={12} md={4} lg={4}>
            <SelectAutocomplete
              label="Región"
              className="select-autocomplete-coopeuch-office-2"
              defaultInputValue=""
              keyPar={["id", "region"]}
              noOptionsMessage={() => "Sin opciones"}
              placeholder=""
              onChange={(item) => {
                setSelectedRegionId(item?.id || item?.value);
                onChangeRegion(item);
              }}
              options={regionsWithOfficesItems}
            />
          </Grid>
          <Grid className="p-0 m-0 pl-md-4" col={12} sm={12} md={4} lg={4}>
            <label htmlFor="office-select" className="label-select-autocomplete">
              Sucursal
            </label>
            <ExternalSelectAutocomplete
              inputId="office-select"
              className="select-autocomplete-coopeuch-office-2 margin-left-office external-select-autocomplete"
              classNamePrefix="select-autocomplete-coopeuch"
              value={{
                value: preferredOffice.value.id,
                label: preferredOffice.value.name,
              }}
              isDisabled={!selectedRegionId}
              noOptionsMessage={() => "Sin opciones"}
              onChange={onChangeOffice}
              options={officesItems}
            />
          </Grid>
          {isVisiblePreferredOffice && (
            <Grid className="p-0 m-0 pl-md-4" col={12} sm={12} md={4} lg={4}>
              <StyledIconOffice>
                <div className="container-map-vector">
                  <img
                    src={MapVector}
                    className="img-map-vector"
                    alt="map vector"
                  />
                  <p className="sucursal-map">
                    Sucursal {preferredOffice.value.commune}
                  </p>
                  <br />
                  <p className="direction-map">
                    {preferredOffice.value.address}
                  </p>
                </div>
              </StyledIconOffice>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid className="m-0 padding-16 p-md-6 border-top border-neutral-alfa-15">
        <Grid className="m-0 p-0">
          <p className="mb-2 font-size-16 font-weight-bold line-height-24">
            ¿Te está atendiendo un ejecutivo?
          </p>
          <WrapperRadio>
            <Radio
              name="accepted"
              label="Sí"
              checked={executiveAttending.value === "SI"}
              onChange={() => handleExecutiveRadioChange("SI")}
            />
          </WrapperRadio>
          <WrapperRadio>
            <Radio
              name="notAccepted"
              label="No"
              checked={executiveAttending.value === "NO"}
              onChange={() => handleExecutiveRadioChange("NO")}
            />
          </WrapperRadio>
        </Grid>
        {executiveAttending.value === "SI" && (
          <Grid className="p-0 m-0 mt-2 d-flex flex-column" row>
            {isLoadingFetchExecutive ? (
              <>
                <Skeleton height="18px" width="180px" mb={4} />
                <Skeleton
                  height="50px"
                  width={isMobileDevice ? "100%" : "270px"}
                  mb={4}
                />
                <Skeleton height="18px" width="50px" mb={0} />
              </>
            ) : (
              renderExecutiveCodeInput()
            )}
          </Grid>
        )}
      </Grid>
    </SimpleCard>
  );
};
/* istanbul ignore next */
CardPreferredOffice.defaultProps = {
  regionsWithOfficesItems: [],
  officesItems: [],
  preferredOffice: {
    value: {
      id: "",
      name: "",
      region: "",
      commune: "",
      address: "",
    },
  },
  executiveCode: {
    value: "",
  },
  executive: {
    nombre: "",
  },
  executiveAttending: {
    value: "",
  },
  isVisiblePreferredOffice: false,
  isLoadingFetchExecutive: false,
  isValidExecutiveCode: "optional",
  isMobileDevice: false,
  disabled: false,
  onChange: () => null,
  onChangeRegion: () => null,
  onChangeOffice: () => null,
  onChangeExecutiveCode: () => null,
};

CardPreferredOffice.propTypes = {
  regionsWithOfficesItems: PropTypes.arrayOf(PropTypes.shape({})),
  officesItems: PropTypes.arrayOf(PropTypes.shape({})),
  preferredOffice: PropTypes.shape({
    value: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      region: PropTypes.string,
      commune: PropTypes.string,
      address: PropTypes.string,
    }),
  }),
  executiveCode: PropTypes.shape({
    value: PropTypes.string,
  }),
  executive: PropTypes.shape({
    nombre: PropTypes.string,
  }),
  executiveAttending: PropTypes.shape({
    value: PropTypes.string,
  }),
  isVisiblePreferredOffice: PropTypes.bool,
  isLoadingFetchExecutive: PropTypes.bool,
  isValidExecutiveCode: PropTypes.string,
  isMobileDevice: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onChangeRegion: PropTypes.func,
  onChangeOffice: PropTypes.func,
  onChangeExecutiveCode: PropTypes.func,
};

export default CardPreferredOffice;